<div class="h-full">
  <router-outlet (activate)="hideLoginLoading()"></router-outlet>
  <if-notification></if-notification>
</div>
